import { Injectable } from "@angular/core";

import { DialogService, MessagePlaceholders } from 'dspx-core';

import { HtmlHelperService } from "./html-helper.service";

@Injectable({
  providedIn: 'root'
})
export class DialogHelperService {

  constructor(
    private dialogService: DialogService,
    private htmlHelperService: HtmlHelperService) {
  }

  showDialog(popupCode: string, placeholders: MessagePlaceholders, data: MessagePlaceholders, dataTitle = this.defaultDialogTitle): void {
    this.dialogService.showDialog(popupCode, null, { ...placeholders, details: this.toHtmlString(data, dataTitle) });
  }

  toHtmlString(data?: MessagePlaceholders, dataTitle = this.defaultDialogTitle): string {
    if (!data) {
      return '';
    }
    const fields = Object
      .entries(data)
      .map(entry => ({
        name: this.htmlHelperService.toEncodedHtml(entry[0]),
        value: this.htmlHelperService.toEncodedHtml(entry[1])
      }));
    if (!fields.length) {
      return '';
    }
    const htmlTitle = dataTitle ? this.htmlHelperService.formatHtml('p', dataTitle) : '';
    const htmlList = this.htmlHelperService.formatFields(fields);
    const htmlString = htmlTitle + htmlList;
    return htmlString;
  }

  private readonly defaultDialogTitle = 'DETAILS:';
}
